import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { UPDATE_GUEST_USER, UPDATE_GUEST_USER_ERROR, UPDATE_GUEST_USER_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* updateGuestUser({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/get-dashboard-data`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: UPDATE_GUEST_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: UPDATE_GUEST_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_GUEST_USER_ERROR, payload: error });
  }
}

export function* watchUpdateGuestUser() {
  yield takeEvery(UPDATE_GUEST_USER, updateGuestUser);
}

function* createUpdateGuestSaga() {
  yield all([fork(watchUpdateGuestUser)]);
}

export default createUpdateGuestSaga;
